<template>
  <div class="plugin pluginStyle daping-dialog2">
    <el-dialog
      :visible.sync="appLicModel"
      :destroy-on-close="true"
      :show-close="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="dialog-title">
        {{ editId.id ? 'Edit Plugin' : 'Add Plugin' }}
        <i class="close-dialog el-icon-close" @click="resetForm()"></i>
      </div>
      <div class="plugin-from">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="124rem"
          class="demo-ruleForm"
        >
          <el-form-item label="Name：" prop="name">
            <el-input
              type="text"
              placeholder="Please enter name"
              style="width: 70%"
              v-model="ruleForm.name"
              :disabled="editId.id ? true : false"
            />
          </el-form-item>
          <!-- <el-form-item label="FileName：" prop="file_name">
            <el-input
              type="text"
              placeholder="Please enter fileName"
              style="width: 70%"
              v-model="ruleForm.file_name"
            />
          </el-form-item> -->
          <el-form-item label="Type：" prop="type">
            <el-select
              placeholder="Please select type"
              class="formInput"
              style="width: 70%"
              v-model="ruleForm.type"
            >
              <!-- <el-option label="elf" value="elf"></el-option>
              <el-option label="script" value="script"></el-option> -->
              <el-option label="shell" value="shell"></el-option>
              <el-option label="test" value="test"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="SubType：" v-if="ruleForm.type == 'test'">
            <el-select
              placeholder="Please select subType"
              class="formInput"
              style="width: 70%"
              v-model="ruleForm.sub_type"
            >
              <el-option
                label="traffic congestion"
                value="traffic congestion"
              ></el-option>
              <el-option
                label="resource consumption"
                value="resource consumption"
              ></el-option>
              <el-option label="smart attack" value="smart attack"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Protocol：" v-if="ruleForm.type == 'test'">
            <el-select
              placeholder="Please select protocol"
              class="formInput"
              style="width: 70%"
              v-model="ruleForm.protocol"
            >
              <el-option
                v-for="item in agreement"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Model：" v-if="ruleForm.type == 'test'">
            <el-select
              placeholder="Please select model"
              class="formInput"
              style="width: 70%"
              v-model="ruleForm.model"
            >
              <el-option label="direct" value="direct"></el-option>
              <el-option
                label="reflection amplification"
                value="reflection amplification"
              ></el-option>
              <el-option label="leak" value="leak"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Args：">
            <el-input
              type="text"
              placeholder="Please enter args"
              style="width: 70%"
              v-model="ruleForm.args"
            />
          </el-form-item>
          <el-form-item label="Remark：">
            <el-input
              type="text"
              placeholder="Please enter remark"
              style="width: 70%"
              v-model="ruleForm.remark"
            />
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <span class="s1" @click="resetForm('ruleForm')">Cancel</span>
        <span class="s2" @click="submitForm('ruleForm')">Save</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAddList, getEditList } from '@/api/plugin';

export default {
  name: 'plugin',
  props: {
    editId: {
      Type: Object,
      default: {},
    },
  },
  data() {
    return {
      appLicModel: false,
      selectList: [],
      ruleForm: {
        name: '',
        // file_name: '',
        type: '',
        args: '',
        remark: '',
        sub_type: '',
        model: '',
        protocol: '',
      },
      agreement: [
        {
          name: 'IP',
          value: 'IP',
        },
        {
          name: 'ICMP',
          value: 'ICMP',
        },
        {
          name: 'TCP',
          value: 'TCP',
        },
        {
          name: 'UDP',
          value: 'UDP',
        },
        {
          name: 'HTTP',
          value: 'HTTP',
        },
        {
          name: 'DNS',
          value: 'DNS',
        },
        {
          name: 'FTP',
          value: 'FTP',
        },
        {
          name: 'SMTP',
          value: 'SMTP',
        },
        {
          name: 'POP3',
          value: 'POP3',
        },
        {
          name: 'RTP',
          value: 'RTP',
        },
        {
          name: 'SIP',
          value: 'SIP',
        },
        {
          name: 'IMAP',
          value: 'IMAP',
        },
        {
          name: 'GRE',
          value: 'GRE',
        },
        {
          name: 'NTP',
          value: 'NTP',
        },
        {
          name: 'HTTPS',
          value: 'HTTPS',
        },
        {
          name: 'STOMP',
          value: 'STOMP',
        },
        {
          name: 'SSL',
          value: 'SSL',
        },
        {
          name: 'SSDP',
          value: 'SSDP',
        },
        {
          name: 'Portmap',
          value: 'Portmap',
        },
        {
          name: 'CLDAP',
          value: 'CLDAP',
        },
        {
          name: 'SNMP',
          value: 'SNMP',
        },
        {
          name: 'COAP',
          value: 'COAP',
        },
      ],

      textType: null,
      rules: {
        name: [
          { required: true, message: 'Please enter name', trigger: 'blur' },
        ],
        file_name: [
          { required: true, message: 'Please enter fileName', trigger: 'blur' },
        ],
        type: [
          { required: true, message: 'Please select type', trigger: 'blur' },
        ],
        args: [
          { required: true, message: 'Please enter args', trigger: 'blur' },
        ],
        remark: [
          { required: true, message: 'Please enter remark', trigger: 'blur' },
        ],
        sub_type: [
          {
            required: true,
            message: 'Please select subType',
            trigger: 'blur',
          },
        ],
        protocol: [
          {
            required: true,
            message: 'Please select protocol',
            trigger: 'blur',
          },
        ],
        model: [
          { required: true, message: 'Please select model', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    editId: {
      handler(val) {
        if (val) {
          this.ruleForm = val;
          console.log(val);
          // this.ruleForm.name = val.contentMd5;
        } else {
          this.ruleForm = {};
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let Parm = { ...this.ruleForm };
          // Parm.name = Parm.name;
          // Parm.name = this.actiOns.contentMd5;

          // Parm.id = this.actiOns.id;
          if (this.editId.id) {
            getEditList(Parm, this.editId.id).then((res) => {
              if (res.data.code == 200) {
                this.$refs[formName].resetFields();
                this.appLicModel = false;
                this.textType = null;
                this.$emit('newDialogFun', true);
                this.$message.success(res.data.msg);
              } else {
                this.$message.error(res.data.msg);
              }
            });
          } else {
            getAddList(Parm).then((res) => {
              if (res.data.code == 200) {
                this.$refs[formName].resetFields();
                this.appLicModel = false;
                this.textType = null;
                this.$emit('newDialogFun', true);
                this.$message.success(res.data.msg);
              } else {
                this.$message.error(res.data.msg);
              }
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.appLicModel = false;
      this.$emit('canCenls', true);
    },
  },
};
</script>

<style scoped lang="less">
.pluginStyle {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  .plugin-from {
    padding-top: 40rem;
  }
  .dialog-footer {
    text-align: right;
    .s1 {
      color: #546afc;
      background: #e8efff;
    }
    .s2 {
      color: #e8efff;
      background: #546afc;
    }
    span {
      border-radius: 10rem 10rem;
      width: 100rem;
      height: 45rem;
      text-align: center;
      font-size: 16rem;
      line-height: 45rem;
      display: inline-block;
      cursor: pointer;
      margin: 0 5rem;
      // border-radius: 10%;
    }
  }
}
</style>
